package br.com.vvrefeicoes.portal.core.util

import kotlinx.coroutines.CancellationException

/**
 * Executa [block] tratando qualquer falha (inclusive erros de rede do Web que não são [Exception]).
 * Retorna `true` quando concluir sem erro; re-lança [CancellationException].
 */
suspend fun guardedLoad(block: suspend () -> Unit): Boolean =
    try {
        block()
        true
    } catch (exception: CancellationException) {
        throw exception
    } catch (throwable: Throwable) {
        false
    }
